import React, { useState } from "react";
import DoctorLayout from "../../Layouts/Doctor/DoctorLayout";

export default function DoctorReports() {
    const [filters, setFilters] = useState({
        patientName: "",
        diagnosis: "",
        date: "",
    });

    const reports = [
        {
            patient: "Ravi Kumar",
            age: 45,
            gender: "Male",
            diagnosis: "Chest Pain",
            prescription: "Paracetamol, BP Tablet",
            reportName: "Blood Report",
            reportIcon: "bi bi-file-earmark-medical text-primary",
            date: "12 Aug 2026",
        },
        {
            patient: "Meena",
            age: 32,
            gender: "Female",
            diagnosis: "Diabetes",
            prescription: "Metformin",
            reportName: "Lab Report",
            reportIcon: "bi bi-file-earmark-medical text-danger",
            date: "11 Aug 2026",
        },
        {
            patient: "Arun",
            age: 28,
            gender: "Male",
            diagnosis: "Headache",
            prescription: "Pain Relief Tablet",
            reportName: "Scan Report",
            reportIcon: "bi bi-file-earmark-medical text-success",
            date: "10 Aug 2026",
        },
        {
            patient: "Ravi Kumar",
            age: 45,
            gender: "Male",
            diagnosis: "Chest Pain",
            prescription: "Paracetamol, BP Tablet",
            reportName: "Blood Report",
            reportIcon: "bi bi-file-earmark-medical text-primary",
            date: "12 Aug 2026",
        },
        {
            patient: "Meena",
            age: 32,
            gender: "Female",
            diagnosis: "Diabetes",
            prescription: "Metformin",
            reportName: "Lab Report",
            reportIcon: "bi bi-file-earmark-medical text-danger",
            date: "11 Aug 2026",
        },
        {
            patient: "Arun",
            age: 28,
            gender: "Male",
            diagnosis: "Headache",
            prescription: "Pain Relief Tablet",
            reportName: "Scan Report",
            reportIcon: "bi bi-file-earmark-medical text-success",
            date: "10 Aug 2026",
        },
        {
            patient: "Ravi Kumar",
            age: 45,
            gender: "Male",
            diagnosis: "Chest Pain",
            prescription: "Paracetamol, BP Tablet",
            reportName: "Blood Report",
            reportIcon: "bi bi-file-earmark-medical text-primary",
            date: "12 Aug 2026",
        },
        {
            patient: "Meena",
            age: 32,
            gender: "Female",
            diagnosis: "Diabetes",
            prescription: "Metformin",
            reportName: "Lab Report",
            reportIcon: "bi bi-file-earmark-medical text-danger",
            date: "11 Aug 2026",
        },
        {
            patient: "Arun",
            age: 28,
            gender: "Male",
            diagnosis: "Headache",
            prescription: "Pain Relief Tablet",
            reportName: "Scan Report",
            reportIcon: "bi bi-file-earmark-medical text-success",
            date: "10 Aug 2026",
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = (e) => {
        e.preventDefault();
        console.log(filters);
    };

    return (
        <DoctorLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border-0 rounded-4 shadow-sm">
                        <div className="card-header bg-white border-0 pt-4 pb-0">
                            <div className="w-100">
                                <div className="bg-light-primary text-primary fw-bold px-4 py-3 rounded-3 fs-7 text-uppercase">
                                    Filter Parameters
                                </div>
                            </div>
                        </div>

                        <div className="card-body p-4">
                            <form onSubmit={handleSearch}>
                                <div className="row g-3 align-items-end">
                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Patient Name
                                        </label>
                                        <input
                                            type="text"
                                            name="patientName"
                                            className="form-control form-control-sm"
                                            placeholder="Search Patient Name"
                                            value={filters.patientName}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Diagnosis
                                        </label>
                                        <select
                                            name="diagnosis"
                                            className="form-select form-select-sm"
                                            value={filters.diagnosis}
                                            onChange={handleChange}
                                        >
                                            <option value="">Filter by Diagnosis</option>
                                            <option value="Chest Pain">Chest Pain</option>
                                            <option value="Diabetes">Diabetes</option>
                                            <option value="Headache">Headache</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <label className="form-label fw-semibold text-muted fs-8 text-uppercase mb-1">
                                            Date
                                        </label>
                                        <input
                                            type="date"
                                            name="date"
                                            className="form-control form-control-sm"
                                            value={filters.date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-2">
                                        <button type="submit" className="btn btn-primary btn-sm px-4 w-100">
                                            <i className="bi bi-search me-2"></i>
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="card border-0 rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed mb-0">
                                    <thead>
                                        <tr className="fw-bold text-dark" style={{ backgroundColor: "#fff1c9" }}>
                                            <th className="ps-5">Patient</th>
                                            <th>Age</th>
                                            <th>Gender</th>
                                            <th>Diagnosis</th>
                                            <th>Prescription</th>
                                            <th>Reports</th>
                                            <th>Date</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody className="fw-semibold text-gray-700">
                                        {reports.map((item, index) => (
                                            <tr key={index}>
                                                <td className="ps-5">{item.patient}</td>
                                                <td>{item.age}</td>
                                                <td>{item.gender}</td>
                                                <td>{item.diagnosis}</td>
                                                <td>{item.prescription}</td>
                                                <td>
                                                    <span className="d-flex align-items-center gap-2">
                                                        <i className={item.reportIcon}></i>
                                                        <span>{item.reportName}</span>
                                                    </span>
                                                </td>
                                                <td>{item.date}</td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <button className="btn btn-primary btn-sm px-3">
                                                            <i className="bi bi-eye me-1"></i>
                                                            View
                                                        </button>
                                                        <button className="btn btn-success btn-sm px-3">
                                                            <i className="bi bi-printer me-1"></i>
                                                            Print
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}

                                        {reports.length === 0 && (
                                            <tr>
                                                <td colSpan="8" className="text-center py-10 text-muted fw-semibold">
                                                    No reports found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DoctorLayout>
    );
}
